module.exports = window.React